import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import MultiSelect from "react-widgets/esm/Multiselect";
import { toast } from "react-toastify";
import { getADUsers } from "../services/soar";
import { ShareWith } from "./supervisionScripts";

function ShareModal({ isOpen, handleClose, submissionData }) {
  const [safyUsers, setSafyUsers] = useState([]);
  const [sharedWith, setSharedWith] = useState([]);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  useEffect(() => {
    const loadUsers = async () => {
      const response = await getADUsers();
      const filteredResponse =
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? response.filter(
              (u) => u.internalemailaddress !== safyInfo.user.email
            )
          : response;

      const users = filteredResponse
        .filter((u) => u.internalemailaddress)
        .map((u) => ({
          key: u.internalemailaddress,
          _id: u.internalemailaddress.toLowerCase(),
          name: u.fullname,
          firstLast: `${u.firstname} ${u.lastname}`,
          azureid: u.azureid,
        }));

      setSafyUsers(users);
    };

    loadUsers();
  }, []);

  const handleShare = async () => {
    console.log("ShareWith", submissionData, sharedWith);
    if (!Array.isArray(submissionData)) {
      submissionData = [submissionData];
    }
    const submissionIds = submissionData.map((s) => s.SubmissionId);
    await ShareWith(submissionIds, sharedWith);
    toast.success("Shared");
    handleClose();
  };

  return (
    <Modal show={isOpen} onHide={handleClose} animation={false} size="lg">
      <Modal.Header closeButton className="bg-safy-info text-white">
        <Modal.Title>Share With</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {submissionData.Related?.filter((r) => r.ObjectType === "Shared")
          .length > 0 ? (
          <div className="mb-4">
            <div className="h5">Shared History</div>
            <div className="row fw-bold">
              <div className="col">Shared With</div>
              <div className="col">Shared By</div>
              <div className="col">Shared On</div>
              <div className="col">Status</div>
            </div>
            {submissionData.Related?.filter(
              (r) => r.ObjectType === "Shared"
            ).map((s, index) => (
              <div key={`shared${s.RelatedId}${index}`}>
                <div className="row">
                  <div className="col">
                    <div>{s.ObjectJSON.name}</div>
                  </div>
                  <div className="col">
                    <div>{s.ObjectJSON.sharedByName}</div>
                  </div>
                  <div className="col">
                    <div>{s.ObjectJSON.date}</div>
                  </div>
                  <div className="col">{s.Active ? "Shared" : "Unshared"}</div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
        {safyUsers.length > 0 ? (
          <div>
            <div className="h6">Select Users to Share With</div>
            <div className="text-danger mb-2">
              *Supervision logs won't be shared until initially signed
            </div>
            <MultiSelect
              name="sharing"
              data={safyUsers}
              dataKey="_id"
              textField="name"
              filter="contains"
              onChange={(e) => {
                const obj = e.map((i) => ({
                  name: i.name,
                  azureId: i.azureid,
                  domain: i._id,
                  sharedById: safyInfo.user.azureId.toUpperCase(),
                  sharedByName: safyInfo.user.displayName,
                  sharedByDomain: safyInfo.user.email,
                  date: new Date().toLocaleDateString(),
                }));
                setSharedWith(obj);
              }}
            />
          </div>
        ) : (
          <div>Loading...</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="btn btn-danger" onClick={handleClose}>
          Close
        </div>
        <div
          className="btn btn-success"
          onClick={() => {
            handleShare();
          }}
        >
          Share
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ShareModal;
